// extracted by mini-css-extract-plugin
export default {"DisplayGrid":"DisplayGrid_DisplayGrid__vRIHx","GridItem":"DisplayGrid_GridItem__0vl0Z"};